/**
 * Created by Stefen Suhat on 6/26/2017.
 */

import { Cookies } from 'react-cookie';

const cookie = new Cookies();

export default cookie;
